import React from 'react';
import styles from './recommendationCardStyles';

import StarIcon from 'buyside/svgs/star.svg';

// these components are meant to be used in conjunction with ./Card.jsx
// see recommendationCardStories.jsx for usage

export const RecommendationCardActionsArea = ({ children }) => {
  return <div className={styles.recommendationActionsArea}>{children}</div>;
};

export const RecommendationItems = ({ children, items = [] }) => {
  return (
    <div className={styles.typeList}>
      {children &&
        typeof children === 'function' &&
        children({ items, itemStyle: styles.typeListItem })}
    </div>
  );
};

export const RecommendationCardHeader = ({ title }) => (
  <div className={styles.recommendationHeaderText}>
    <StarIcon className={styles.starIcon} />
    {title}
  </div>
);

export const RecommendationCard = ({ children }) => {
  return <div className={styles.recommendationContainer}>{children}</div>;
};

export default RecommendationCard;
